/**
 * 日付が変わったら（0:00を跨いだら）カートの中身を削除する機能
 * 
 * このスクリプトは以下の処理を行います：
 * 1. ローカルストレージに最後にチェックした日付を保存
 * 2. ページロード時に現在の日付を確認
 * 3. 日付が変わっていたら、Shopify Cart APIを使ってカートをクリア
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'last_cart_check_date';
  const JST_OFFSET = 9 * 60 * 60 * 1000; // JSTはUTC+9時間

  /**
   * 現在のJST日付を取得（YYYY-MM-DD形式）
   */
  function getCurrentJSTDate() {
    const now = new Date();
    const jstTime = new Date(now.getTime() + JST_OFFSET);
    const year = jstTime.getUTCFullYear();
    const month = String(jstTime.getUTCMonth() + 1).padStart(2, '0');
    const day = String(jstTime.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /**
   * ローカルストレージから最後のチェック日を取得
   */
  function getLastCheckDate() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      console.error('ローカルストレージの読み取りに失敗しました:', e);
      return null;
    }
  }

  /**
   * ローカルストレージに現在の日付を保存
   */
  function saveCurrentDate(date) {
    try {
      localStorage.setItem(STORAGE_KEY, date);
    } catch (e) {
      console.error('ローカルストレージへの保存に失敗しました:', e);
    }
  }

  /**
   * Shopify Cart APIを使用してカートをクリア
   */
  async function clearCart() {
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        console.log('日付が変わったためカートをクリアしました');
        
        // カート数を表示している要素を更新
        updateCartCount(0);
        
        // カスタムイベントを発火してカートドロワーなどを更新
        document.dispatchEvent(new CustomEvent('cart:cleared'));
        
        return true;
      } else {
        console.error('カートのクリアに失敗しました:', response.status);
        return false;
      }
    } catch (error) {
      console.error('カートのクリア処理でエラーが発生しました:', error);
      return false;
    }
  }

  /**
   * カート数の表示を更新
   */
  function updateCartCount(count) {
    // カート数を表示している要素を探して更新
    const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count, [data-header-cart-count]');
    cartCountElements.forEach(element => {
      element.textContent = count;
      
      // 数が0の場合は非表示にする処理（テーマによって異なる場合がある）
      if (count === 0) {
        element.classList.add('hidden');
      }
    });
  }

  /**
   * メイン処理
   */
  async function checkAndClearCartIfDateChanged() {
    const currentDate = getCurrentJSTDate();
    const lastCheckDate = getLastCheckDate();

    console.log('カート日付チェック:', {
      currentDate: currentDate,
      lastCheckDate: lastCheckDate
    });

    // 初回訪問の場合は現在の日付を保存するだけ
    if (!lastCheckDate) {
      console.log('初回訪問のため日付を保存します');
      saveCurrentDate(currentDate);
      return;
    }

    // 日付が変わっていたらカートをクリア
    if (currentDate !== lastCheckDate) {
      console.log('日付が変わりました。カートをクリアします。');
      const cleared = await clearCart();
      
      if (cleared) {
        // カートクリア後に日付を更新
        saveCurrentDate(currentDate);
      }
    } else {
      console.log('日付は変わっていません');
    }
  }

  // DOMの読み込みが完了したら実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndClearCartIfDateChanged);
  } else {
    // すでに読み込み済みの場合は即実行
    checkAndClearCartIfDateChanged();
  }

})();

